import { produce } from 'immer'
import type { State } from '../typings'
import type { ISearchResponse } from '@sales-center/common'
import type { BestFitResponse } from '@user/store/scheduling'

export type SetDataAction = {
  type: 'setData'
  payload?: ISearchResponse<BestFitResponse>
}

export const setDataAction = (
  state: State,
  payload?: SetDataAction['payload'],
) =>
  produce(state, (draft) => {
    draft.loading = false
    draft.response = payload
  })

export const setDataActionCreator = (
  payload?: SetDataAction['payload'],
): SetDataAction => ({ type: 'setData', payload })
